import { render, staticRenderFns } from "./open-resto.vue?vue&type=template&id=3ecb8156&scoped=true"
import script from "./open-resto.vue?vue&type=script&lang=js"
export * from "./open-resto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecb8156",
  null
  
)

export default component.exports